import React from 'react';

const Loader = ({ size = 'md', text = 'Loading...', className = '', isDarkMode = false, fullScreen = false }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  const WrapperComponent = fullScreen ? 'div' : 'span';

  return (
    <WrapperComponent className={`flex items-center justify-center transition-colors duration-300 ${
      fullScreen ? `min-h-screen ${isDarkMode ? 'bg-skyone-page-dark' : 'bg-gray-50'}` : ''
    } ${className}`}>
      <div className="flex flex-col items-center space-y-2">
        <div className={`${sizeClasses[size]} border-2 rounded-full animate-spin transition-colors duration-300 ${
          isDarkMode 
            ? 'border-gray-600 border-t-blue-400' 
            : 'border-gray-300 border-t-primary-600'
        }`}></div>
        {text && (
          <p className={`text-sm transition-colors duration-300 ${
            isDarkMode ? 'text-gray-300' : 'text-gray-600'
          }`}>{text}</p>
        )}
      </div>
    </WrapperComponent>
  );
};

export default Loader;
